import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { UpdateRefundBody } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Dependencies } from "src/redux/store";

export const updateRefund = createAsyncThunk<void, { id: string; body: UpdateRefundBody }, { extra: Partial<Dependencies> }>(
  "refunds/updateRefund",
  async ({ id, body }: { id: string; body: UpdateRefundBody }, { extra: { adminRepository } }) => {
    return adminRepository!.updateRefund(id, body);
  },
);

export const resetUpdateRefund = createAction("refunds/resetUpdateRefund");
